<template>
  <!-- .home-type1-root 与 postcss-scope-type1 配合，限制 find-base / type1-style 仅作用于本子树 -->
  <div class="home-type1-root">
    <div id="finds-type1-home"
         ref="t1Page"
         class="t1-page"
         @pointerenter="onPtrEnter"
         @pointerleave="onPtrLeave"
         @pointermove="onPtrMove">
      <div class="grid-focus"
           aria-hidden="true"></div>
      <div ref="glowEl"
           class="cursor-glow"
           aria-hidden="true"></div>

      <HomeTopbar :is-mobile="state.isMobile"
                  :homeInfo="homeInfo"
                  :defaultMenuList="menuList"
                  :expertConfig="expertConfig"
                  @change-expert="handleChangeExpert" />

      <main>
        <section class="hero section-wrap first-screen">
          <div class="hero-copy">
            <h1 class="hero-word-reveal"
                :aria-label="homeInfo?.homeContent?.title1">
              <p v-for="(w, wi) in heroWords"
                 :key="'w' + wi"
                 class="hero-word"
                 :style="wordStyle(wi)">
                {{ w }}
              </p>
            </h1>

            <FilterCondition v-if="state.isMobile"
                             :menuList="menuList" />

            <div class="actions">
              <router-link class="btn btn-solid products-btn"
                           to="/goods">
                Best Sellers
              </router-link>
              <a class="community-btn"
                 v-if="homeInfo?.homeContent?.links?.[0]?.title"
                 target="_blank"
                 :href="homeInfo?.homeContent?.links?.[0]?.linkAddress">
                JOIN OUR {{ homeInfo?.homeContent?.links?.[0]?.title }}

                <i class="el-icon-top-right"></i>
              </a>
            </div>

            <div class="link-wrap"
                 v-if="homeInfo?.homeContent?.tutorialInfo">
              <div class="link-wrap__left">
                <p class="link-title">
                  {{ homeInfo?.homeContent?.tutorialInfo?.title || '' }}
                </p>
                <p class="link-desc">
                  {{ homeInfo?.homeContent?.tutorialInfo?.intro || '' }}
                </p>
              </div>
              <a class="link-wrap__right"
                 target="_blank"
                 :href="homeInfo?.homeContent?.tutorialInfo?.link || ''">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="2"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                     class="lucide lucide-play w-4 w-4"
                     aria-hidden="true">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"></path>
                </svg>
                {{ homeInfo?.homeContent?.tutorialInfo?.buttonName || '' }}
              </a>
            </div>
          </div>

          <!-- 畅销商品墙 -->
          <HomeProductWall :is-mobile="state.isMobile"
                           :lock-mobile="state.isMobile && _lockIosMobile"
                           :shelf-items="homeInfo?.goodsList?.['Best Selling']"
                           :col-reverse="colReverse"
                           :selectPlatform="selectPlatform" />
        </section>

        <!-- 分类 -->
        <HomeFeaturedCategories :goodsList="homeInfo?.goodsList"
                                :lock-mobile="state.isMobile && _lockIosMobile" />

        <!-- 套餐 -->
        <HomeOutfits v-if="homeInfo?.goodsList?.Suit && homeInfo?.goodsList?.Suit.length > 0"
                     :is-mobile="state.isMobile"
                     :lock-mobile="state.isMobile && _lockIosMobile"
                     :homeInfo="homeInfo"
                     :selectPlatform="selectPlatform" />

        <section class="kakobuy-promo kakobuy-promo--footer section-wrap"
                 aria-label="Agent signup">
          <div class="kakobuy-promo-inner">
            <div class="kakobuy-promo-copy">
              <p class="kakobuy-promo-head"
                 v-for="(title, index) in kakobuyPromoHead"
                 :key="`kakobuy-promo-head-${index}`">
                {{ title }}
              </p>
            </div>
            <div class="kakobuy-promo-visual">
              <img v-if="homeInfo?.homeContent?.pcImage2"
                   :src="homeInfo?.homeContent?.pcImage2"
                   class="promo-swing"
                   alt="FINDS packaging boxes"
                   loading="lazy"
                   @click="handleImageClick" />
            </div>
          </div>
        </section>

        <section class="community">
          <p class="community__title">
            NEED HELP?
          </p>
          <p class="community__tip">
            JOIN THE COMMUNITY
          </p>
          <p class="community__tip">
            FOR 24/7 Support
          </p>
          <div class="community__links">
            <a v-for="(item, idx) in socialList"
               :key="item.linkAddress || idx"
               :href="item.linkAddress"
               target="_blank">
              <span class="social-icon-html"
                    v-html="item.url" />
            </a>
          </div>
        </section>
      </main>

      <footer class="t1-ft"
              id="t1-ft">
        <div class="section-wrap t1-ft-grid">
          <div>
            <div class="kakobuy-promo-visual pc-image3">
              <img v-if="homeInfo?.homeContent?.pcImage3"
                   :src="homeInfo?.homeContent?.pcImage3"
                   alt="FINDS packaging boxes"
                   loading="lazy" />
            </div>
            <p v-for="(info, index) in websiteInfo"
               :key="`website-info-${index}`">
              {{ info }}
            </p>

            <p style="margin-top: 20px">
              {{ siteDomain }} © 2026
            </p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import HomeFeaturedCategories from './module/home-featured-categories/index.vue'
import HomeOutfits from './module/home-outfits/index.vue'
import FilterCondition from './module/filter-condition/index.vue'
import { setupCategoryMarquee } from './finds-marquee'
import HomeProductWall from './module/product-wall/index.vue'
import HomeTopbar from './module/home-topbar.vue'
import productApi from '@/api/product'

const ZOOM_SELECTOR = [
  '.topbar',
  '.hero-copy .kicker',
  '.hero-copy .actions',
  '.featured .title-row > *',
  '.category-row a',
  '.faq-title',
  '.faq-sub',
  '.faq-item',
  '.need-help > *',
  '.kakobuy-promo-inner > *',
].join(', ')

export default {
  name: 'HomeType1',

  components: {
    HomeFeaturedCategories,
    HomeOutfits,
    FilterCondition,
    HomeProductWall,
    HomeTopbar
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({})
    },
    expertConfig: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      selectPlatform: {},
      /** 交互与局部 UI */
      state: {
        signupOpen: true,
        /** 当前展开的 FAQ 索引，仅一项展开 */
        faqOpen: 0,
        /** 小屏布局标记：首屏改为上下 + 单轨横向滚动 */
        isMobile: false,
        /** 类目数量不足以溢出时，禁用跑马灯并启用静态布局 */
        categoryStatic: false
      },
      colReverse: [false, true, false],
      _ioZoom: null,
      _ptrMove: null,
      _ptrLeave: null,
      _ptrEnter: null,
      _resizeInit: null,
      _resizeViewport: null,
      _catDragCleanup: null,
      _catLoopDistance: 0,
      _lockIosMobile: false,
      menuList: []
    }
  },

  computed: {
    // 达人 id，供子组件拉取分类等数据
    expertId() {
      return this.expertConfig?.expert?.id || this.homeInfo?.expert?.id || ''
    },

    heroWords() {
      return String(this.homeInfo?.homeContent?.title1 || '')
        .trim()
        .split('##')
        .filter(Boolean)
    },

    kakobuyPromoHead() {
      return this.homeInfo?.homeContent?.title4?.split('##').filter(Boolean) || []
    },

    websiteInfo() {
      return this.homeInfo?.homeContent?.title5?.split('##').filter(Boolean) || []
    },

    siteDomain() {
      if (typeof window === 'undefined') {
        return ''
      }
      return window.location.hostname || ''
    },

    categoryLoop() {
      const base = (this.homeInfo?.goodsList?.['Categories'] || []).map((c, i) => ({
        ...c,
        _uid: c.key + '-' + i
      }))

      return [...base, ...base, ...base, ...base].map((c, idx) => ({
        ...c,
        _uid: c._uid + '-r' + idx
      }))
    },

    catPeriodLen() {
      return this.homeInfo?.goodsList?.['Categories']?.length || 0
    },
    footerFindsLinks() {
      return [
        { label: 'Outfits', path: '/goods' },
        { label: 'Sellers', path: '/home' },
        { label: 'Videos', path: '/goods' },
        { label: 'FAQ', path: '/home', hash: '#faq' }
      ]
    },

    socialList() {
      return this.homeInfo?.homeContent?.links?.filter((item) => item.enabled === 'Y') || []
    }
  },

  created() {
    this.getHomeConfig()
  },

  mounted() {
    this._lockIosMobile = this.isIosMobile()
    this.syncViewportMode()
    if (!this._lockIosMobile) {
      this._resizeViewport = () => this.syncViewportMode()
      window.addEventListener('resize', this._resizeViewport)
    }
    this.initZoomReveal()
  },

  beforeDestroy() {
    if (this._resizeViewport) window.removeEventListener('resize', this._resizeViewport)
    this.teardownCategoryMarquee()
    this.teardownCategoryDrag()
    this.teardownZoom()
  },

  methods: {
    isIosMobile() {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
      const ua = navigator.userAgent || ''
      const platform = navigator.platform || ''
      const maxTouchPoints = navigator.maxTouchPoints || 0
      const isIosUa = /iPhone|iPad|iPod/i.test(ua)
      // iPadOS 13+ 可能上报 MacIntel
      const isIpadOs = platform === 'MacIntel' && maxTouchPoints > 1
      return isIosUa || isIpadOs
    },

    // 获取首页菜单配置
    async getHomeConfig() {
      try {
        const res = await productApi.getHomeConfig()
        this.menuList = res.data?.menuList || []
      } catch (e) {
        this.menuList = []
      }
    },

    handleChangeExpert(platform) {
      this.selectPlatform = platform
    },

    wordStyle(idx) {
      return { '--word-delay': `${idx * 210}ms` }
    },
    toggleFaq(i) {
      this.state.faqOpen = this.state.faqOpen === i ? -1 : i
    },
    footerLinkProps(l) {
      if (l.hash) return { to: { path: l.path || '/home', hash: l.hash } }
      return { to: l.path || '/goods' }
    },
    onPtrMove(e) {
      if (this.state.isMobile) return
      const root = this.$refs.t1Page
      const glow = this.$refs.glowEl
      if (!root || !glow) return
      glow.style.left = `${e.clientX}px`
      glow.style.top = `${e.clientY}px`
      root.style.setProperty('--cursor-x', `${e.clientX}px`)
      root.style.setProperty('--cursor-y', `${e.clientY}px`)
    },
    onPtrLeave() {
      const glow = this.$refs.glowEl
      if (glow) glow.style.opacity = '0'
    },
    onPtrEnter() {
      if (this.state.isMobile) return
      const glow = this.$refs.glowEl
      if (glow) glow.style.opacity = '0.55'
    },
    syncViewportMode() {
      if (this._lockIosMobile) {
        this.state.isMobile = true
        return
      }
      const nextIsMobile = window.innerWidth <= 980
      if (nextIsMobile === this.state.isMobile) return
      this.state.isMobile = nextIsMobile
    },
    teardownCategoryMarquee() {
      const row = this.$refs.catRow
      if (row && row._marquee) {
        row._marquee.cancel()
        row._marquee = null
      }
    },
    teardownCategoryDrag() {
      if (typeof this._catDragCleanup === 'function') {
        this._catDragCleanup()
      }
      this._catDragCleanup = null
    },
    bindCategoryDrag() {
      this.teardownCategoryDrag()
      const row = this.$refs.catRow
      const wrap = row?.parentElement
      if (!row || !wrap || !this._catLoopDistance) return

      const drag = {
        active: false,
        moved: false,
        startX: 0,
        startTime: 0
      }

      const onPointerDown = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return
        if (!row._marquee) return
        drag.active = true
        drag.moved = false
        drag.startX = event.clientX
        drag.startTime = Number(row._marquee.currentTime || 0)
        row._marquee.pause()
        wrap.classList.add('is-dragging')
      }

      const onPointerMove = (event) => {
        if (!drag.active || !row._marquee || !this._catLoopDistance) return
        const deltaX = event.clientX - drag.startX
        if (!drag.moved && Math.abs(deltaX) > 4) {
          drag.moved = true
        }
        const timing = row._marquee.effect?.getTiming?.() || {}
        const duration = Number(timing.duration) || 0
        if (!duration) return
        const deltaTime = (-deltaX / this._catLoopDistance) * duration
        row._marquee.currentTime = drag.startTime + deltaTime
        if (drag.moved) {
          event.preventDefault()
        }
      }

      const onPointerUp = (event) => {
        if (!drag.active) return
        drag.active = false
        wrap.classList.remove('is-dragging')
        if (row._marquee) {
          row._marquee.play()
        }
      }

      const onClickCapture = (event) => {
        if (!drag.moved) return
        event.preventDefault()
        event.stopPropagation()
        // 仅拦截一次“拖拽结束后的误触点击”，避免后续正常点击被持续拦截。
        drag.moved = false
      }

      const onNativeDragStart = (event) => {
        event.preventDefault()
      }

      const onSelectStart = (event) => {
        event.preventDefault()
      }

      wrap.addEventListener('pointerdown', onPointerDown)
      wrap.addEventListener('pointermove', onPointerMove)
      wrap.addEventListener('pointerup', onPointerUp)
      wrap.addEventListener('pointercancel', onPointerUp)
      wrap.addEventListener('pointerleave', onPointerUp)
      row.addEventListener('dragstart', onNativeDragStart)
      row.addEventListener('selectstart', onSelectStart)
      row.addEventListener('click', onClickCapture, true)

      this._catDragCleanup = () => {
        wrap.classList.remove('is-dragging')
        wrap.removeEventListener('pointerdown', onPointerDown)
        wrap.removeEventListener('pointermove', onPointerMove)
        wrap.removeEventListener('pointerup', onPointerUp)
        wrap.removeEventListener('pointercancel', onPointerUp)
        wrap.removeEventListener('pointerleave', onPointerUp)
        row.removeEventListener('dragstart', onNativeDragStart)
        row.removeEventListener('selectstart', onSelectStart)
        row.removeEventListener('click', onClickCapture, true)
      }
    },
    initCategoryMarquee() {
      this.teardownCategoryMarquee()
      this.teardownCategoryDrag()
      this._catLoopDistance = 0
      const row = this.$refs.catRow
      if (!row) return

      const parentWidth = row.parentElement?.clientWidth || 0
      const children = Array.from(row.children)
      const style = getComputedStyle(row)
      const gapPx = Number.parseFloat(style.columnGap || style.gap || '0') || 0
      const contentWidth = children.reduce((sum, el, idx) => {
        const next = sum + el.offsetWidth
        return idx < children.length - 1 ? next + gapPx : next
      }, 0)

      // 内容不足一屏时保持静态，避免无意义滚动。
      const shouldStatic = contentWidth <= parentWidth + 2
      this.state.categoryStatic = shouldStatic
      if (shouldStatic) return

      this._catLoopDistance = setupCategoryMarquee(row, this.catPeriodLen)
      this.bindCategoryDrag()
    },
    initZoomReveal() {
      const root = this.$refs.t1Page
      if (!root) return
      const targets = root.querySelectorAll(ZOOM_SELECTOR)
      if (!targets.length) return
      targets.forEach((el, idx) => {
        el.classList.add('zoom-reveal')
        el.style.setProperty('--zoom-delay', `${(idx % 10) * 35}ms`)
      })
      const reveal = (el) => {
        if (el.classList.contains('is-visible')) return
        requestAnimationFrame(() => el.classList.add('is-visible'))
      }
      if (!('IntersectionObserver' in window)) {
        targets.forEach(reveal)
        return
      }
      this._ioZoom = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            reveal(entry.target)
            this._ioZoom.unobserve(entry.target)
          })
        },
        { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
      )
      targets.forEach((el) => this._ioZoom.observe(el))
    },
    teardownZoom() {
      if (this._ioZoom) {
        this._ioZoom.disconnect()
        this._ioZoom = null
      }
    },

    handleImageClick() {
      const link = this.homeInfo?.homeContent?.pcImageLink2
      if (link) {
        window.open(link, '_blank')
      }
    }
  }
}
</script>

<!-- scoped：本页 @import 的样式仅作用于本组件 DOM；PostCSS 再前缀 .home-type1-root，不改 find-base / type1-style 源文件 -->
<style scoped lang="scss">
@import './styles/type1-style.scss';
@import './styles/find-base.css';

.community-btn {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--primary-color);
  border-radius: 10px;
  font-size: 18px;
  color: var(--primary-color) !important;
  font-family: 'Roboto Mono', monospace !important;
  font-weight: 600;
  text-transform: uppercase;

  .el-icon-top-right {
    position: relative;
    top: 1px;
    transition: transform 0.3s ease;
  }
}

.community-btn:hover {
  scale: 1.08;

  .el-icon-top-right {
    transform: rotate(45deg);
  }
}

/* 作用域根不参与盒模型，避免多一层影响 .t1-page 的 min-height 等 */
.home-type1-root {
  display: contents;
}

.hero {
  padding: 0 !important;
  max-width: none !important;
}

/* 围绕左侧锚点做往返摆动，幅度控制在 20deg */
.promo-swing {
  --sw-scale: 1;
  -webkit-transform-origin: left center;
  transform-origin: left center;
  -webkit-animation: promo-swing-5 10s ease-in-out infinite;
  animation: promo-swing-5 10s ease-in-out infinite;
  -webkit-will-change: transform;
  will-change: transform;
}

.kakobuy-promo-visual {
  -webkit-transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  -webkit-transform-origin: left center;
  transform-origin: left center;
}

.kakobuy-promo-visual:hover {
  -webkit-transform: scale(1.08);
  transform: scale(1.08);
}

@-webkit-keyframes promo-swing-5 {
  0% {
    -webkit-transform: rotate(-5deg) scale(var(--sw-scale));
    transform: rotate(-5deg) scale(var(--sw-scale));
  }

  50% {
    -webkit-transform: rotate(5deg) scale(var(--sw-scale));
    transform: rotate(5deg) scale(var(--sw-scale));
  }

  100% {
    -webkit-transform: rotate(-5deg) scale(var(--sw-scale));
    transform: rotate(-5deg) scale(var(--sw-scale));
  }
}

@keyframes promo-swing-5 {
  0% {
    -webkit-transform: rotate(-5deg) scale(var(--sw-scale));
    transform: rotate(-5deg) scale(var(--sw-scale));
  }

  50% {
    -webkit-transform: rotate(5deg) scale(var(--sw-scale));
    transform: rotate(5deg) scale(var(--sw-scale));
  }

  100% {
    -webkit-transform: rotate(-5deg) scale(var(--sw-scale));
    transform: rotate(-5deg) scale(var(--sw-scale));
  }
}

.link-wrap {
  margin-right: 60px;
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  border-radius: 10px;
  background: hsl(from var(--select-border-color) h s l / .8);
  color: var(--primary-color);
  font-family: 'Roboto Mono', monospace !important;
  text-align: left;
  text-transform: uppercase;

  &__left,
  &__right {
    margin: auto;
  }

  &__left {
    flex: 1;
  }

  &__right {
    width: 120px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    color: var(--primary-color) !important;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Roboto Mono', monospace !important;
    border: 1px solid var(--primary-color);

    svg {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }

  .link-title {
    margin-bottom: 1px;
    font-size: 24px;
    font-weight: 600;
  }

  .link-desc {
    font-size: 14px;
    font-weight: 400;
  }
}

@media(max-width: 980px) {
  .link-wrap {
    padding: 8px 16px;
    margin-right: 0;
  }

  .link-title {
    font-size: 18px !important;
  }

  .link-desc {
    font-size: 12px !important;
  }

  .link-wrap__right {
    width: 100%;
  }
}

@media(max-width: 768px) {
  .actions {
    flex-wrap: wrap;

    .products-btn,
    .community-btn {
      flex: auto;
      font-size: 16px !important;
    }
  }
}
</style>
